<template>
  <div class="menu">
      <div class="nav-items">
        <ul class="menu-items">
          <GlobalAudioPlayer title="Lyd" />
          <TogglePageElementsMenuItem />
          <MenuItemFav title="Favoritter"/>
          <MenuItem :icon-name="zoom ?  'icon-minify' : 'icon-magnify'" @click="toggleZoom" title="Zoom" />
          <MenuItemEdit />
          <MenuItemColorSelect title="Velg farge" />
          <MenuItemSettings title="Innstillinger"/>
          <MenuItem icon-name="icon-backward" class="navigation" tooltip="Forrige side" @click="goToPreviousPage" title="Forrige side" />
          <MenuItem icon-name="icon-forward" class="navigation" @click="goToNextPage" title="Neste side" />
          <Pagination />
        </ul>
      </div>
  </div>
</template>

<script>
import MenuItem from '@/components/MenuItem'
import MenuItemFav from './MenuItemFav'
import MenuItemEdit from './MenuItemEdit'
import MenuItemColorSelect from './MenuItemColorSelect'
import MenuItemSettings from './MenuItemSettings'
import GlobalAudioPlayer from './GlobalAudioPlayer'
import TogglePageElementsMenuItem from './TogglePageElementsMenuItem'
import Pagination from './Pagination'
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'goToNextPage',
      'goToPreviousPage',
      'toggleZoom'
    ])
  },
  computed: {
    ...mapGetters([
      'fullscreen',
      'zoom'
    ])
  },
  components: {
    MenuItem,
    MenuItemFav,
    MenuItemEdit,
    MenuItemColorSelect,
    MenuItemSettings,
    Pagination,
    GlobalAudioPlayer,
    TogglePageElementsMenuItem
  }
}
</script>

<style>

</style>
